import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('VORTEX_SUCK', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  const invP = 1 - progress;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2 + progress * 5;
    const dist = 100 * invP * invP;
    const x = e.pos.x + Math.cos(angle) * dist;
    const y = e.pos.y + Math.sin(angle) * dist;

    ctx.fillStyle = determineColor(i, particles);
    ctx.globalAlpha = progress;
    ctx.beginPath(); ctx.arc(x, y, 3, 0, Math.PI * 2); ctx.fill();
  }
});
